// ============================================================
// Dashboard Overview (New) — Remaining dummy/config data
// Live data is derived in hooks/useDashboardData.js
// ============================================================

export const OVERALL_PRODUCTIVITY_DATA = {
  score: 82,
  label: 'Good',
  trendPct: 12,
  trendUp: true,
  teamAvg: 74,
};

export const KEY_HIGHLIGHTS_DATA = [
  {
    id: 'active-time',
    label: 'Active Time',
    value: '6h 32m',
    trendPct: 8,
    trendUnit: '%',
    trendUp: true,
    sublabel: '72%',
    sublabelSuffix: 'of total time',
    iconType: 'clock',
    iconBg: '#EEF4FF',
    iconColor: '#4F7EF8',
  },
  {
    id: 'idle-time',
    label: 'Idle Time',
    value: '1h 15m',
    trendPct: 18,
    trendUnit: '%',
    trendUp: false,
    sublabel: '14%',
    sublabelSuffix: 'of total time',
    iconType: 'coffee',
    iconBg: '#FFF6ED',
    iconColor: '#f59e0b',
  },
  {
    id: 'attendance',
    label: 'Attendance',
    value: '96%',
    trendPct: 4,
    trendUnit: '%',
    trendUp: true,
    sublabel: '27/28',
    sublabelSuffix: 'present',
    iconType: 'users',
    iconBg: '#ECFDF3',
    iconColor: '#22c55e',
  },
  {
    id: 'focus-time',
    label: 'Focus Time',
    value: '3h 48m',
    trendPct: 15,
    trendUnit: '%',
    trendUp: true,
    sublabel: '48%',
    sublabelSuffix: 'of active time',
    iconType: 'target',
    iconBg: '#EEF4FF',
    iconColor: '#4F7EF8',
  },
  {
    id: 'alerts',
    label: 'Alerts',
    value: '12',
    trendPct: 5,
    trendUnit: '',
    trendUp: true,
    sublabel: 'View all alerts',
    sublabelLink: true,
    iconType: 'shield',
    iconBg: '#FFF1F3',
    iconColor: '#ef4444',
  },
];

// Show only key time labels on x-axis
export const PRODUCTIVITY_CHART_TICKS = [
  '12 AM',
  '4 AM',
  '8 AM',
  '12 PM',
  '4 PM',
  '8 PM',
  '12 AM',
];

// 7 days × 13 time slots — intensity 0.0–1.0 (used only as fallback reference)
const H = (v) => v;
export const ACTIVITY_HEATMAP_DATA = [
  {
    day: 'Mon',
    slots: [
      H(0.1),
      H(0.0),
      H(0.0),
      H(0.2),
      H(0.4),
      H(0.6),
      H(0.8),
      H(0.9),
      H(0.7),
      H(0.5),
      H(0.4),
      H(0.3),
      H(0.1),
    ],
  },
  {
    day: 'Tue',
    slots: [
      H(0.0),
      H(0.0),
      H(0.1),
      H(0.3),
      H(0.5),
      H(0.7),
      H(0.9),
      H(1.0),
      H(0.8),
      H(0.6),
      H(0.5),
      H(0.2),
      H(0.0),
    ],
  },
  {
    day: 'Wed',
    slots: [
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.1),
      H(0.3),
      H(0.5),
      H(0.7),
      H(0.8),
      H(0.6),
      H(0.4),
      H(0.3),
      H(0.1),
      H(0.0),
    ],
  },
  {
    day: 'Thu',
    slots: [
      H(0.1),
      H(0.0),
      H(0.1),
      H(0.4),
      H(0.6),
      H(0.8),
      H(0.9),
      H(0.9),
      H(0.7),
      H(0.5),
      H(0.4),
      H(0.2),
      H(0.0),
    ],
  },
  {
    day: 'Fri',
    slots: [
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.2),
      H(0.4),
      H(0.7),
      H(0.8),
      H(0.7),
      H(0.5),
      H(0.4),
      H(0.3),
      H(0.1),
      H(0.0),
    ],
  },
  {
    day: 'Sat',
    slots: [
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.1),
      H(0.2),
      H(0.3),
      H(0.2),
      H(0.1),
      H(0.1),
      H(0.0),
      H(0.0),
      H(0.0),
    ],
  },
  {
    day: 'Sun',
    slots: [
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.1),
      H(0.2),
      H(0.1),
      H(0.1),
      H(0.0),
      H(0.0),
      H(0.0),
      H(0.0),
    ],
  },
];
export const HEATMAP_TIME_LABELS = [
  '12 AM',
  '1 AM',
  '2 AM',
  '3 AM',
  '4 AM',
  '5 AM',
  '6 AM',
  '7 AM',
  '8 AM',
  '9 AM',
  '10 AM',
  '11 AM',
  '12 PM',
  '1 PM',
  '2 PM',
  '3 PM',
  '4 PM',
  '5 PM',
  '6 PM',
  '7 PM',
  '8 PM',
  '9 PM',
  '10 PM',
  '11 PM',
];

export const AI_INSIGHTS_DATA = [
  {
    id: 'insight-1',
    iconType: 'trending-up',
    iconBg: '#ECFDF3',
    iconColor: '#22c55e',
    title: 'Productivity increased by 12%',
    desc: 'Team productivity is higher than yesterday.',
  },
  {
    id: 'insight-2',
    iconType: 'alert',
    iconBg: '#FFF6ED',
    iconColor: '#f59e0b',
    title: 'Idle time unusually high',
    desc: 'Idle time spiked after 2 PM for 6 employees.',
  },
  {
    id: 'insight-3',
    iconType: 'star',
    iconBg: '#EEF4FF',
    iconColor: '#4F7EF8',
    title: 'Top performer today',
    desc: 'Ayush Windows has the highest productivity.',
  },
  {
    id: 'insight-4',
    iconType: 'warning',
    iconBg: '#FFF1F3',
    iconColor: '#ef4444',
    title: 'Unusual app usage detected',
    desc: 'High usage of Social Media apps detected.',
  },
];

const sparkUp = [10, 25, 20, 40, 35, 55, 50];
const sparkMid = [30, 28, 35, 25, 40, 30, 38];
const sparkDown = [50, 42, 38, 30, 25, 20, 15];

export const TEAM_PERFORMANCE_DATA = [
  {
    id: 'emp-1',
    name: 'Ayush Windows',
    role: 'UI/UX Designer',
    avatar: 'AW',
    avatarBg: '#EEF4FF',
    avatarColor: '#4F7EF8',
    productivityScore: 92,
    scoreTrend: 15,
    scoreTrendUp: true,
    activeTime: '7h 12m',
    idleTime: '45m',
    focusTime: '4h 32m',
    attendance: '100%',
    attendanceStatus: 'Present',
    sparkline: sparkUp,
    sparkColor: '#22c55e',
  },
  {
    id: 'emp-2',
    name: 'Rahul Sharma',
    role: 'Frontend Developer',
    avatar: 'RS',
    avatarBg: '#ECFDF3',
    avatarColor: '#22c55e',
    productivityScore: 78,
    scoreTrend: 8,
    scoreTrendUp: true,
    activeTime: '6h 05m',
    idleTime: '1h 10m',
    focusTime: '3h 20m',
    attendance: '100%',
    attendanceStatus: 'Present',
    sparkline: sparkMid,
    sparkColor: '#22c55e',
  },
  {
    id: 'emp-3',
    name: 'Priya Verma',
    role: 'Project Manager',
    avatar: 'PV',
    avatarBg: '#FFF1F3',
    avatarColor: '#ef4444',
    productivityScore: 65,
    scoreTrend: 5,
    scoreTrendUp: false,
    activeTime: '4h 45m',
    idleTime: '1h 35m',
    focusTime: '2h 10m',
    attendance: '90%',
    attendanceStatus: 'Late',
    sparkline: sparkDown,
    sparkColor: '#f59e0b',
  },
  {
    id: 'emp-4',
    name: 'Neha Patel',
    role: 'Marketing Executive',
    avatar: 'NP',
    avatarBg: '#FFF6ED',
    avatarColor: '#f59e0b',
    productivityScore: 88,
    scoreTrend: 12,
    scoreTrendUp: true,
    activeTime: '6h 48m',
    idleTime: '50m',
    focusTime: '3h 50m',
    attendance: '100%',
    attendanceStatus: 'Present',
    sparkline: sparkUp,
    sparkColor: '#22c55e',
  },
  {
    id: 'emp-5',
    name: 'Arjun Mehta',
    role: 'Backend Developer',
    avatar: 'AM',
    avatarBg: '#F4F3FF',
    avatarColor: '#7a5af8',
    productivityScore: 70,
    scoreTrend: 3,
    scoreTrendUp: true,
    activeTime: '5h 20m',
    idleTime: '1h 20m',
    focusTime: '2h 45m',
    attendance: '100%',
    attendanceStatus: 'Present',
    sparkline: sparkMid,
    sparkColor: '#22c55e',
  },
];
